import { Injectable } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { ApiResponse } from '../interfaces/response.interface';
import { Observable, throwError } from 'rxjs';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { QueryParams } from '../interfaces/request.interface';
import { ToastrService } from 'ngx-toastr';
import { Material } from '../interfaces/material.interface';
import { DATA_SOURCE, environment } from 'src/environments/environment';
import { AbstractHttpController } from '../utils/class/AbstractHttpControllers';
import { PartialNestedObject } from '../interfaces/common.interface';

@Injectable({
  providedIn: 'root'
})
export class MaterialsService extends AbstractHttpController<Material>{
  protected _endpoint: string;
  protected _queryParams: QueryParams<Material>;
  public get queryParams(): QueryParams<Material> {
    return this._queryParams;
  }
  public set queryParams(queryParams: QueryParams<Material>) {
    this._queryParams = queryParams;
  }
  public make(args?: PartialNestedObject<Material>): Observable<ApiResponse<Material>> {
    throw new Error('Method not implemented.');
  }
  public find(args?: PartialNestedObject<Material>): Observable<ApiResponse<Material[]>> {
    throw new Error('Method not implemented.');
  }
  public findOne(args?: PartialNestedObject<Material>): Observable<ApiResponse<Material>> {
    throw new Error('Method not implemented.');
  }
  public findBy(args?: PartialNestedObject<Material>): Observable<ApiResponse<Material[]>> {
    return this.read({
      datasource:DATA_SOURCE.DMAESTROS,
      path:`${this._endpoint}/short-Portafolio`,
      queryParams:this._queryParams,
    })
  }
  public remove(args?: PartialNestedObject<Material>): Observable<ApiResponse<Material>> {
    throw new Error('Method not implemented.');
  }
  constructor(
    private readonly _httpClient: HttpClient,
  ) {
    super(_httpClient);
    this._endpoint = 'material';
  }
}
